import { Card, Result, message } from "antd";
import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { loginUsingTokenAction } from "../store/action/admin/authActions";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
function Success() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramValue = searchParams.get("token");
  const dispatch = useDispatch();
  const loginWithToken = async () => {
    try {
      await dispatch(loginUsingTokenAction(paramValue));
    } catch (err) {
      message.error(err);
    }
  };
  useEffect(() => {
    loginWithToken();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <Card style={{ maxWidth: "400px" }}>
        <Result
          status="success"
          title="Success!"
          subTitle={
            <>
              <span>Redirecting to dashboard, please wait.</span>
              <CustomLoaderIcon />
            </>
          }
        />
      </Card>
    </div>
  );
}

export default Success;
